<div class="wrap">

    <div class="margin-large-bottom-res margin-large-top-res">
        <ul class="uk-flex-center" uk-tab>
            <li [class.uk-active]="tab === 0">
                <a (click)="changeTab(0)">Utilisateurs</a>
            </li>
            <li [class.uk-active]="tab === 1">
                <a (click)="changeTab(1)">Staff</a>
            </li>
        </ul>
    </div>

    <div class="uk-form-stacked">

        <div class="uk-margin uk-display-inline-block research-form-controls search">
            <div class="uk-form-controls uk-display-inline-block uk-position-relative uk-width-1-1">
                <button class="uk-form-icon uk-form-icon-flip pointer" type="submit"
                    style="border: none; background: inherit;">
                    <img src="../../../../assets/icons/Search.svg" width="24px" height="24px" alt="user" />
                </button>
                <form>
                    <input name="recherche" autocomplete="off" id="search-bar" class="search-bar" type="text"
                        [(ngModel)]="search" (ngModelChange)="onSearchChange($event)" placeholder="Rechercher"
                        ng-reflect-model="">
                </form>
            </div>
        </div>

        <button class="button bold button-align uk-display-inline-block uk-float-right uk-margin-left uk-margin-bottom"
            uk-toggle="target: #add-user" type="button" *ngIf="session.role.ability === 'super-admin' || session.role.ability === 'admin'">
            <span>Nouvel utilisateur</span>
            <img src="../../../assets/icons/Add.svg" width="32px" height="32px" alt="back" class="uk-margin-left">
        </button>

        <button class="button bold button-align uk-display-inline-block uk-float-right" (click)="exportDataAsXLSX()"
            type="button">
            <span *ngIf="excelLoading === false">
                <span class="vertical-align-middle">Export</span>
                <img src="../../../../assets/icons/Export.svg" width="32px" height="32px" alt="user"
                    class="uk-margin-left" />
            </span>
            <span *ngIf="excelLoading === true">
                <div uk-spinner class="loading-small-button"></div>
            </span>
        </button>

    </div>

    <div *ngIf="loadingStatus === false && noResult === false" class="uk-width-1-1@s uk-align-center uk-display-inline-block">
        <div class="uk-form-controls uk-display-inline-block uk-margin-small-right">
            <button class="uk-button round-button uk-display-inline-block@m"
                [class.round-button-toggle]="filtre === 0" (click)="changeFiltre(0)">Tout</button>
        </div>
        <div class="uk-form-controls uk-display-inline-block uk-margin-small-right">
            <button class="uk-button bg-color-red round-button uk-display-inline-block@m"
                [class.round-button-toggle-green]="filtre === 1" (click)="changeFiltre(1)">Activé</button>
        </div>
        <div class="uk-form-controls uk-display-inline-block">
            <button class="uk-button round-button uk-display-inline-block@m"
                [class.round-button-toggle-red]="filtre === 2" (click)="changeFiltre(2)">Désactivé</button>
        </div>
    </div>

    <div *ngIf="noResult === true" class="bold uk-margin-medium-top">
        Vous n'avez pas d'utilisateurs.
    </div>

    <div *ngIf="loadingStatus === true" class="uk-position-center">
        <div uk-spinner></div>
    </div>

    <div *ngIf="loadingStatus === false && noResult === false" style="margin-top: 50px;">

        <div *ngIf="session.role.ability === 'admin'" uk-grid
            class="remove-grid-ml-pl uk-margin-remove-top uk-width-1-1">

            <div *ngIf="filteredUsers.length === 0" class="bold uk-width-1-1">
                <div>Aucun élément trouvé</div>
            </div>

            <a href="#" uk-grid *ngFor="let user of filteredUsers; let i = index"
                class="uk-width-1-1 item-list remove-grid-ml-pl pointer"
                [routerLink]="['/user/informations', user.AccountId]">
                <div class="uk-visible@m uk-width-1-12 item-column">
                    <img class="list-avatar" [src]="user.ProfilePicture"
                        onerror="this.src='../../../assets/icons/User.svg';this.style.borderRadius='0';this.style.objectFit='contain';"
                        alt="user" />
                </div>
                <div class="uk-width-3-12 item-column bold uk-text-uppercase" style="font-size: 15px;">
                    <span>{{ user.LastName }} {{ user.FirstName }}</span>
                </div>
                <!-- <div class="uk-width-1-12 item-column">
                    <span *ngIf="false" class=" color-cold-grey light" style="font-size: 17px;">
                        PRO
                    </span>
                </div> -->
                <div class="uk-visible@m uk-width-1-12 item-column">
                    <span *ngIf="user.IdAccountDemo > 0" class="color-cold-grey light" style="font-size: 17px;">
                        STAFF
                    </span>
                </div>
                <!-- <div class="uk-visible@m uk-width-2-12 item-column">
                    <span *ngIf="user.IdAccountDemo > 0" class="color-cold-grey item-status bold" style="font-size: 17px;">
                        {{ user.CodeSociety }}
                    </span>
                </div> -->
                <div class="uk-visible@s uk-width-2-12 item-column">
                    <span class="item-status light" style="font-size: 13px;">
                        {{ user.CodeSociety }}
                    </span>
                </div>
                <div class="uk-align-center">
                    <span class="color-cold-grey bold uk-width-1-12 uk-text-uppercase"
                        *ngIf="user.IdDisabledAccount > 0">
                        <span class="material-icons color-red">fiber_manual_record</span>
                    </span>
                    <span class="color-cold-grey bold uk-width-1-12 uk-text-uppercase"
                        *ngIf="user.IdDisabledAccount == 0">
                        <span class="material-icons color-green">fiber_manual_record</span>
                    </span>
                </div>
                <!-- <div class="uk-width-expand item-column"></div> -->
                <div class="uk-width-1-12 item-column">
                    <img class="uk-position-absolute" style="right: 10px;"
                        src="../../../assets/icons/TRIANGLE Right.svg" width="48px" height="48px" alt="user" />
                </div>
            </a>

        </div>

        <div *ngIf="session.role.ability === 'super-admin'" uk-grid
            class="remove-grid-ml-pl uk-margin-remove-top uk-width-1-1">

            <div *ngIf="filteredUsers.length === 0" class="bold uk-width-1-1">
                <div>Aucun élément trouvé</div>
            </div>

            <a href="#" uk-grid *ngFor="let user of filteredUsers; let i = index"
                class="uk-width-1-1 item-list alt color-grey remove-grid-ml-pl pointer"
                [routerLink]="['/user/informations', user.AccountId]">
                <div class="uk-visible@m uk-width-1-12 item-column">
                    <img class="uk-position-absolute" style="left: 10px;" src="../../../assets/icons/User.svg"
                        width="48px" height="48px" alt="adherent" />
                </div>
                <div class="uk-width-4-12 item-column bold uk-text-uppercase" style="font-size: 15px;">
                    <span>{{ user.LastName }} {{ user.FirstName }}</span>
                </div>
                <div *ngIf="false" class="uk-visible@l uk-width-1-12 item-column">
                    <span class="item-status light" style="font-size: 13px;">
                        PRO
                    </span>
                </div>
                <div class="uk-visible@l uk-width-1-12 item-column">
                    <span *ngIf="user.IdAccountDemo > 0" class="item-status light" style="font-size: 13px;">
                        STAFF
                    </span>
                </div>
                <div class="uk-width-3-12 item-column">
                    <span class="item-status light" style="font-size: 13px;">
                        {{ user.CodeSociety }}
                    </span>
                </div>
                <div class="uk-visible@m uk-width-1-12 item-column">
                    <span humanDateFormat="{{ user.ISODateCreation }}" noDay="true" shortened="true"></span>
                </div>
                <div class="uk-align-center">
                    <span class="color-cold-grey bold uk-width-1-12 uk-text-uppercase"
                        *ngIf="user.IdDisabledAccount > 0">
                        <span class="material-icons color-red">fiber_manual_record</span>
                    </span>
                    <span class="color-cold-grey bold uk-width-1-12 uk-text-uppercase"
                        *ngIf="user.IdDisabledAccount == 0">
                        <span class="material-icons color-green">fiber_manual_record</span>
                    </span>
                </div>
                <!-- <div class="uk-hidden@l uk-width-expand item-column"></div> -->
                <div class="uk-width-1-12 item-column">
                    <div class="arrow-button">
                        <img src="../../../assets/icons/ArrowRight.svg" width="30px" height="30px" alt="user" />
                    </div>
                </div>
            </a>

        </div>

        <div class="uk-margin-large" *ngIf="maxPages === 0"></div>

        <div class="uk-position-relative uk-width-1-1 uk-padding uk-margin" *ngIf="maxPages > 0">
            <div class="uk-position-center">
                <button [disabled]="currentPage === 1" class="uk-button button" (click)="prevPage()">Précédent</button>
                <div class="uk-display-inline-block" *ngFor="let item of [].constructor(maxPages); let i = index;">
                    <div *ngIf="currentPage === i + 1" class="bold uk-margin-left vop-blue">{{i + 1}}</div>
                    <div *ngIf="currentPage !== i + 1" class="uk-margin-left pointer vop-blue" (click)="goPage(i + 1)">
                        {{i + 1}}</div>
                </div>
                <button [disabled]="currentPage === maxPages" class="uk-button button uk-margin-left"
                    (click)="nextPage()">Suivant</button>
            </div>
        </div>
    </div>

</div>

<app-add-user (changed)="updateUsers()"></app-add-user>